import { render } from "./HomeView.vue?vue&type=template&id=003f0ed1&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=003f0ed1&lang=scss&scoped=true"

import exportComponent from "/Users/gabrielvoissiere/Documents/Developpement/Developpement prs/npm package/simply_wave_demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-003f0ed1"]])

export default __exports__